import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { Divider } from '../../styles';
import { CustomerInformation } from '../../interfaces/Cart';
import TMarkUp from '../TMarkUp';

const DetailsSection = styled.div`
  padding: 1.5rem 0;

  h3 {
    margin-bottom: 1.25rem;
  }
`;

export const DetailSectionMY: React.FC<CustomerInformation> = ({
  firstName,
  lastName,
  addressFieldInfo,
  postCode,
  city,
  state,
  email,
  phoneNumber,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp value={t('spareParts.summary.delivery.title')} />
        </h3>
        <div>{`${firstName} ${lastName}`}</div>
        <div>{addressFieldInfo}</div>
        <div>{`${postCode} ${city}`}</div>
        <div>{state}</div>
        <div>Malaysia</div>
      </DetailsSection>
      <Divider />
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp
            value={t('spareParts.summary.delivery.contactInformation')}
          />
        </h3>
        <div>{phoneNumber}</div>
        <div>{email}</div>
      </DetailsSection>
    </>
  );
};

export default DetailSectionMY;
